import React from 'react';
import { FlexContainer, ModalCloseButton, ModalContainer, Text } from '../styles';
import { CLOSE_NEW_ICON, INFO_NEW_ICON } from '@Images';
import { FONT_FAMILY } from '../../../../../common/styles/fontStyles';
import { COLORS } from '@Commons';
import { FUND_TRANSFER_MODAL } from '../../../utils/constants';
import { formatCurrencyAmount, formatCurrencyToTwoDecimalPlaces } from '@Utils/library';
import { IFundTransfer } from '../../../utils/interface';
import { BankDetailsCard, Timer } from '@Components';

const FundTransfer = (props: IFundTransfer): React.ReactElement => {
  const { payInBankDetails, transactionDetails, onClose, remainingTime, isReferral } = props;
  const selectedDetails = isReferral ? payInBankDetails[0] : payInBankDetails[1];
  const fundData = [
    { key: FUND_TRANSFER_MODAL.accName, value: selectedDetails.accountName },
    { key: FUND_TRANSFER_MODAL.accNumber, value: selectedDetails.accountNumber },
    { key: FUND_TRANSFER_MODAL.ifsc, value: selectedDetails.routingCode?.IFSC },
    { key: FUND_TRANSFER_MODAL.bankName, value: selectedDetails.bankName },
    { key: FUND_TRANSFER_MODAL.branch, value: selectedDetails.address },
    {
      key: FUND_TRANSFER_MODAL.txnNumber,
      value: transactionDetails.transaction_number,
      extraInfo: FUND_TRANSFER_MODAL.txnDetails
    }
  ];

  return (
    <ModalContainer>
      <ModalCloseButton onClick={onClose}>
        <img src={CLOSE_NEW_ICON} alt="close" />
      </ModalCloseButton>
      <Text fontSize="18px">{FUND_TRANSFER_MODAL.heading}</Text>
      <FlexContainer row align="center">
        <Text fontSize="24px">
          {formatCurrencyAmount(
            formatCurrencyToTwoDecimalPlaces(transactionDetails.net_source_amount)
          )}
        </Text>
        <Text fontSize="14px" padding="8px 0 2px 5px">
          {transactionDetails.source_currency || ''}
        </Text>
      </FlexContainer>
      <FlexContainer row align="center" padding="0 0 24px 0">
        <Text
          fontSize="12px"
          lineHeight="22px"
          fontFamily={FONT_FAMILY.hellix.regular}
          color={COLORS.disabled}
        >
          {FUND_TRANSFER_MODAL.validFor}
        </Text>
        {remainingTime ? (
          <Text fontSize="12px" lineHeight="22px" padding="0 0 0 4px" color={COLORS.textLightGrey}>
            <Timer
              hours={remainingTime.hours || 0}
              minutes={remainingTime.minutes || 0}
              seconds={remainingTime.seconds || 0}
            />
          </Text>
        ) : null}
      </FlexContainer>
      <BankDetailsCard dataArray={fundData} />
      <FlexContainer
        row
        padding="12px 16px"
        margin="24px 0"
        backgroundColor={COLORS.lightShadedGrey}
        border={`1px solid ${COLORS.borderGrey}`}
        borderRadius="4px"
        align="start"
      >
        <img src={INFO_NEW_ICON} alt="info" />
        <Text
          padding="0 0 0 12px"
          color={COLORS.textGrey}
          lineHeight="22px"
          fontSize="14px"
          fontFamily={FONT_FAMILY.hellix.regular}
          textAlign="start"
        >
          {FUND_TRANSFER_MODAL.infoTextPart1}
          <span className="boldText">{FUND_TRANSFER_MODAL.infoTextPart2}</span>
          {FUND_TRANSFER_MODAL.infoTextPart3}
        </Text>
      </FlexContainer>
    </ModalContainer>
  );
};

export default FundTransfer;
